/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Signout1Inputs */

const zh_user_signout1 = /** @type {(inputs: User_Signout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const en_user_signout1 = /** @type {(inputs: User_Signout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out`)
};

const es_user_signout1 = /** @type {(inputs: User_Signout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {User_Signout1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const user_signout1 = /** @type {((inputs?: User_Signout1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Signout1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_user_signout1(inputs)
	if (locale === "en") return en_user_signout1(inputs)
	return es_user_signout1(inputs)
});
export { user_signout1 as "user_signOut" }